import hooks from './invitations.hooks';
import createSchema from './invitations.schema';

export default (app) => {
  const service = app.service('api/invitations');
  service.schema = createSchema(app);
  service.hooks(hooks);
};
